import { gsap } from 'gsap';
import { SplitText } from 'gsap/SplitText.js';

/** Componsante TextAnim de TimTools */
export default class Animator {
  /**
   * Méthode constructeur
   * @param {HTMLElement} element - Élément HTML sur lequel la composante est instanciée
   */
  constructor(element) {
    this.element = element;
    this.options = {
      repeat: true,
    };
    this.anim = {};

    gsap.registerPlugin(SplitText);

    // this.init();
    document.fonts.ready.then(this.init.bind(this));
  }

  init() {
    this.setOptions();

    this.initAnim();
    this.initObserver();
  }
  initObserver() {
    const observer = new IntersectionObserver(this.watch.bind(this), {
      rootMargin: '0px 0px 0px 0px',
    });
    observer.observe(this.element);
  }

  initAnim() {
    this.anim.type = this.element.dataset.anim;
    switch (this.anim.type) {
      case 'letterReveal':
        this.initLetterReveal();
        break;
      case 'rotate':
        this.initRotate();
        break;
      case 'flipChilds':
        this.initFlipChilds();
        break;
      case 'scaleChilds':
        this.initScaleChilds();
        break;
      default:
        console.error("You don't have data-anim valid");
        break;
    }
  }

  initLetterReveal() {
    const split = SplitText.create(this.element, {
      mask: 'chars',
      type: 'chars, words',
      autoSplit: true,
    });
    gsap.set(split.chars, {
      yPercent: 'random([-100,100])', // animate from 100px below
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
    });
    this.anim.out = gsap.to(split.chars, {
      duration: 1,
      yPercent: 'random([-100,100])', // animate from 100px below
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
      stagger: 0.05, // 0.05 seconds between each
      delay: 0.25,
      ease: 'expo.out',
      paused: true,
    });
    this.anim.in = gsap.to(split.chars, {
      duration: 1,
      yPercent: 0, // animate from 100px below
      autoAlpha: 1, // fade in from opacity: 0 and visibility: hidden
      stagger: 0.05, // 0.05 seconds between each
      delay: 0.25,
      ease: 'expo.out',
      paused: true,
    });
  }

  initRotate() {
    gsap.set(this.element, {
      scale: 0, // animate from 100px below
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
      rotate: 180,
    });
    this.anim.out = gsap.to(this.element, {
      duration: 0,
      scale: 0, // animate from 100px below
      rotate: 180,
      autoAlpha: 0, // fade in from opacity: 0 and visibility: hidden
      delay: 0.25,
      ease: 'expo.out',
      paused: true,
    });
    this.anim.in = gsap.to(this.element, {
      duration: 1,
      scale: 1, // animate from 100px below
      autoAlpha: 1, // fade in from opacity: 0 and visibility: hidden
      rotate: 0,
      delay: 0.25,
      ease: 'back.out',
      paused: true,
    });
  }
  initFlipChilds() {
    const childs = this.element.children;
    console.log(childs);

    gsap.set(childs, {
      transformOrigin: 'top',
      rotationX: 90,
      autoAlpha: 0,
      z: 100,
      y: 200,

      // opacity: 0,
    });

    this.anim.out = gsap.to(childs, {
      duration: 0,
      transformOrigin: 'top',
      rotationX: 90,
      autoAlpha: 0,
      y: 100,
      delay: 0.5,
      stagger: 0.1,
      ease: 'expo.out',
      paused: true,
    });
    this.anim.in = gsap.to(childs, {
      transformOrigin: 'top',
      duration: 1.5,
      rotationX: 0,
      autoAlpha: 1,
      z: 0,
      // opacity: 1,
      y: 0,
      delay: 0.5,
      stagger: 0.2,
      ease: 'expo.out',
      paused: true,
    });
  }
  initScaleChilds() {
    const childs = this.element.children;

    gsap.set(childs, {
      transformOrigin: 'center',
      scale: 0,
    });

    this.anim.out = gsap.to(childs, {
      duration: 0,
      transformOrigin: 'center',
      scale: 0,
      stagger: 0.1,
      autoAlpha: 0,
      ease: 'expo.out',
      paused: true,
    });
    this.anim.in = gsap.to(childs, {
      transformOrigin: 'center',
      duration: 1,
      scale: 1,
      autoAlpha: 1,
      stagger: 0.1,
      ease: 'back.out(1, 0.4)',
      paused: true,
    });
  }
  animOut() {
    this.anim.out.restart();
  }
  animIn() {
    console.log(this.anim);
    this.anim.in.restart();
  }

  watch(entries, observer) {
    for (let i = 0; i < entries.length; i++) {
      const entry = entries[i];
      const target = entry.target;

      if (entry.isIntersecting) {
        this.animIn();
        //this.anim(true)
        if (!this.options.repeat) observer.unobserve(target);
      } else {
        this.animOut();
        // this.anim(false)
      }
    }
  }

  setOptions() {
    if ('repeat' in this.element.dataset) {
      this.options.repeat = true;
    }
  }
}
